import { render, staticRenderFns } from "./areaSearch.vue?vue&type=template&id=9b617300&scoped=true&"
import script from "./areaSearch.vue?vue&type=script&lang=js&"
export * from "./areaSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b617300",
  null
  
)

export default component.exports